import AbstractInfoPages from "../AbstractInfoPages";
import {inject, injectable} from "inversify";
import SERVICE_IDENTIFIER from "../../constants/identifiers";
import SystemConfig from "../../system/SystemConfig";

@injectable()
export default class PixiInfoPages extends AbstractInfoPages {

    constructor(@inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig) {

        super(config);

    }

    /**
     * @override
     */
    home() {}

    /**
     * @override
     */
    next() {}

    /**
     * @override
     */
    prev() {}

    showWintable() {
        super.showWintable();
    };

    hideWintable() {
        super.hideWintable();
    };

    showGame() {
        super.showGame();
    };
    hideGame() {
        super.hideGame()
    };

    onBetChange() {
    }

    onRoundStart() {
    }
}